import { ThemeDefinition } from "@hackthenorth/north";
import { css } from "styled-components";

export const textSharedStyles = css`
  font-family: ${({ theme }) => theme.globalConstants.fontFamily.body};
  font-size: ${({ theme }) => theme.globalConstants.fontSize.body}px;
  line-height: 26px;

  color: ${({ theme }) => theme.globalConstants.color.textDark};
  margin: 0;
  display: inline;
`;

export const textModifiers = {
  // font family
  heading: css`
    font-family: ${({ theme }) => theme.globalConstants.fontFamily.heading};
    line-height: normal;
    display: block;
    margin-bottom: 0.2em;
    margin-top: 0.5em;
    color: ${({ theme }) => theme.globalConstants.color.textDark};
  `,

  block: css`
    display: block;
  `,

  // sizes
  title: css`
    font-size: ${({ theme }) => theme.globalConstants.fontSize.title}px;
  `,
  h1: css`
    font-size: ${({ theme }) => theme.globalConstants.fontSize.h1}px;

    ${({ theme }) => theme.mediaQueries.largeMobile`
      font-size: ${theme.globalConstants.fontSize.hmobile}px;
    `}
  `,
  h2: css`
    font-size: ${({ theme }) => theme.globalConstants.fontSize.h2}px;
  `,
  hmobile: css`
    font-size: ${({ theme }) => theme.globalConstants.fontSize.hmobile}px;
  `,
  h3: css`
    font-size: ${({ theme }) => theme.globalConstants.fontSize.h3}px;
  `,
  big: css`
    font-size: ${({ theme }) => theme.globalConstants.fontSize.bodyBig}px;
    line-height: 29px;
  `,
  subtle: css`
    font-size: ${({ theme }) => theme.globalConstants.fontSize.bodySubtle}px;
    line-height: 22px;
  `,

  // colors
  error: css`
    color: ${({ theme }) => theme.globalConstants.color.redSecondary};
  `,
  greenSecondary: css`
    color: ${({ theme }) => theme.globalConstants.color.greenSecondary};
  `,
  success: css`
    color: ${({ theme }) => theme.globalConstants.color.greenSecondary};
  `,
  grey: css`
    color: ${({ theme }) => theme.globalConstants.color.textGrey};
  `,
  lightGrey: css`
    color: ${({ theme }) => theme.globalConstants.color.textLightGrey};
  `,
  tanSecondary: css`
    color: ${({ theme }) => theme.globalConstants.color.tanSecondary};
  `,
  bluePrimary2: css`
    color: ${({ theme }) => theme.globalConstants.color.bluePrimary2};
  `,

  // other
  bold: css`
    font-weight: bold;
  `,
  medium: css`
    font-weight: 500;
  `,
  italic: css`
    font-style: italic;
  `,
  center: css`
    text-align: center;
  `,
  "lh-regular": css`
    line-height: 1.5;
  `,
  "no-decoration": css`
    text-decoration: none;
  `,
  code: css`
    font-family: ${({ theme }) => theme.globalConstants.fontFamily.code};
    color: ${({ theme }) => theme.globalConstants.color.navySecondary};
    background-color: ${({ theme }) =>
      theme.globalConstants.color.bluePrimary3};
    border-radius: 4px;
    padding: 1px 4px;
  `,

  link: css`
    color: ${({ theme }) => theme.globalConstants.color.bluePrimary2};
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  `,
  rgNumberPickerCount: css`
    min-width: 2em;
    text-align: center;
    display: inline-block;
    white-space: nowrap;
  `,
  rgRequestInfoHeader: css`
    display: flex;
    align-items: center;
    > span {
      flex: 1;
    }
  `,
  rgNoMarginTop: css`
    margin-top: 0;
  `,
  rgMiddle: css`
    vertical-align: middle;
  `,
  robogooseSkurowRight: css`
    white-space: nowrap;
    color: ${({ theme }) => theme.globalConstants.color.textLightGrey};
  `,
};

export const textStyles: ThemeDefinition["text"] = {
  sharedStyles: textSharedStyles,
  modifiers: textModifiers,
};
